import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, CardHeader, CircularProgress, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Tab, Tabs, Typography, makeStyles } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getItemDetailsDataService } from "./item-tabs-service";
import { useDispatch, useSelector } from "react-redux";
import { db } from "../../../../../../firebase";
import ItemPhotosContainer from "./item-photos/item-photos-container";
import ItemInformationContainer from "./item-information/item-information-container";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  button: {
      background: "#111111",
      color: "#fbbbd3",
      '&:hover': {
          backgroundColor: '#fbbbd3',
          color: '#111111',
      },
  },
  buttonText: {
      color: "#111111",
      '&:hover': {
          backgroundColor: '#fbbbd3',
          color: '#111111',
      },
  },
  text: {
      color: "#111111",
  },
  expandArrowIcon: {
    color: "#fbbbd3",
  },
  title: {
      background:"#111111",
  },
  expandPanel: {
    background:"#111111",
  }
}));

const ItemTabsEmpty = () => {
    const classes = useStyles();
    const { item_id } = useParams();
    const isLoading = useSelector((state) => state.itemTabsSlice.isLoading);
    const itemInformation = useSelector((state) => state.itemInformationListSlice.itemInformation);
    const [value, setValue] = useState(0);
    const [infoExpanded, setInfoExpanded] = useState(true);
    const [photosExpanded, setPhotosExpanded] = useState(true);
    const navigate = useNavigate();
    const dispatch = useDispatch();


    useEffect(() => {
        if (item_id) {
            const fetchData = async () => {
                try {
                    await getItemDetailsDataService(dispatch, db, "items", item_id);
                } catch(e) {
                    console.error("ItemTabs fetchData error: ", e);
                }
            };
            fetchData();
        }
    }, [item_id]);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const handleBack = () => {
      navigate('/admin/items');
    };

    const panelExpanded = value === 0 || value === 1;
  
    return (
        <>
            <Card
                variant="outlined"
                style={{
                    marginTop: '5vh',
                    padding: '5vh',
                }}
            >
                <div style={{ display: "flex", alignItems: "center", marginBottom: 10}}>
                    <Button
                        variant="text"
                        className={classes.buttonText}
                        startIcon={<ArrowBack/>}
                        onClick={handleBack}
                    >
                    Back
                    </Button>
                </div>
                <Typography variant="h2" component="div" className={classes.text} align="left">
                    {itemInformation.name}
                </Typography>
                <CardContent>
                    <Accordion expanded={infoExpanded}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon className={classes.expandArrowIcon}/>}
                            onClick={() => setInfoExpanded(!infoExpanded)}
                            aria-controls="info-content"
                            id="info-header"
                            className={classes.expandPanel}
                        >
                            <Typography>Info</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 10 }}>
                            {infoExpanded &&
                                <div style={{ display: "center", alignItems: "center", marginTop: 10}}>
                                    <Typography className={classes.typography}>
                                        No data found.
                                    </Typography>
                                </div>
                            }
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={photosExpanded}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon className={classes.expandArrowIcon}/>}
                            onClick={() => setPhotosExpanded(!photosExpanded)}
                            aria-controls="photos-content"
                            id="photos-header"
                            className={classes.expandPanel}
                        >
                            <Typography>Photos</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 10 }}>
                            {photosExpanded &&
                                <div style={{ display: "center", alignItems: "center", marginTop: 10}}>
                                    <Typography className={classes.typography}>
                                        No data found.
                                    </Typography>
                                </div>
                            }
                        </AccordionDetails>
                    </Accordion>
                    {/* <Tabs value={value} onChange={handleChange} aria-label="My Tabs">
                    <Tab label="Info" />
                    <Tab label="Photos" />
                    </Tabs>

                    {value === 0 && (
                        <ItemInformationContainer item_id={item_id}/>
                    )}

                    {value === 1 && (
                        <ItemPhotosContainer item_id={item_id}/>
                    )} */}
                </CardContent>
            </Card>
        </>
    );
  };
  
  export default ItemTabsEmpty;